import { Image, Spin, Popover, Button } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { MoreOutlined } from "@ant-design/icons";
import useAxios from "axios-hooks";
import { Resource } from "../../../../api/common";
import { getImagePath } from "../../../../utils/getImagePath";

export const MaterialItemListItem = ({ item, refetch }: any) => {
   const history = useHistory();
   const location = useLocation();
   const [t] = useTranslation();

   const [material, updateMaterial] = useState<any>(item);
   const [pgData, setPgData] = useState<any>();
   const [{ data: productGroupData }] = useAxios(
      {
         url: `${Resource.path.getProductGroupDetails}/${item.product_group_id}`,
         method: "GET"
      },
      { manual: false }
   );

   useEffect(() => {
      if (item) {
         updateMaterial(item);
      }
      if (productGroupData?.data) {
         setPgData(productGroupData?.data);
      }
   }, [item, productGroupData]);

   const [isTriggerByDate, setIsTriggerByDate] = useState(false);
   const [isAvailableToSell, setIsAvailableToSell] = useState(
      item.available_for_sell
   );
   const [previousDate, setPreviousDate] = useState();
   const [previousMaterialAvailableDate, setPreviousMaterialAvailableDate] =
      useState<any>();

   const [{ data: _data, loading: _loading, error: _error }, executeGet] =
      useAxios(
         {
            url: `${Resource.path.cloneMaterialSpecHub}/${item.id}`,
            method: "GET"
         },
         { manual: true }
      );

   const [
      {
         data: deleteOperationData,
         loading: deleteOperationLoading,
         error: deleteOperationError
      },
      executeDelete
   ] = useAxios(
      {
         url: `${Resource.path.removeMaterialPassportHub}/${item.id}`,
         method: "DELETE"
      },
      { manual: true }
   );

   if (deleteOperationLoading) {
      (window as any).NProgress.start();
   } else {
      (window as any).NProgress.done();
   }

   const navigateToDetailsPage = () => {
      history.push({
         pathname: `${location.pathname}/${item.id}`,
         state: { material, showAddPassport: false }
      });
   };

   const handleMaterialDelete = async () => {
      await executeDelete();
      refetch();
   };

   const handleClone = async () => {
      await executeGet().then((response) => {
         if (response?.data?.data) {
            history.push({
               pathname: `${location.pathname}/edit/${response?.data?.data}/product_details`
            });
         }
      });
      //await refetch();
   };

   const imagePath =
      item?.images && item?.images.length
         ? item?.images[0]
         : item?.default_material_image;

   return (
      <Spin spinning={deleteOperationLoading}>
         <div className="material-row-item">
            <div className="item" onClick={navigateToDetailsPage}>
               <Image
                  width={120}
                  height={120}
                  src={
                     getImagePath(imagePath, {
                        resize: {
                           fit: "cover",
                           width: 120
                        }
                     }) || "error"
                  }
                  preview={false}
                  fallback="data:image/png;base64,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"
               />
               <div className="item-title">
                  <span className="product-group-label">
                     {item?.product_group_name}
                  </span>

                  <strong>
                     {item?.manufacturer} {item?.product_name}
                  </strong>
                  {item?.total_amount && (
                     <>
                        {item?.total_amount % 1 != 0
                           ? String(
                                parseFloat(item?.total_amount).toFixed(2)
                             ).replace(".", ",")
                           : item?.total_amount}{" "}
                        {item?.amount_unit}
                     </>
                  )}
               </div>
            </div>
            {pgData && pgData?.obdProductUuid && (
               <div className="item-title">
                  <br />
                  {parseFloat(pgData?.gwp_a1a3 + pgData?.gwp_c4).toFixed(
                     2
                  )}{" "}
                  {pgData?.lca_unit}
               </div>
            )}

            <div className="menu">
               <Popover
                  content={
                     <>
                        <div>
                           <Button onClick={handleClone} type="text">
                              clone
                           </Button>
                        </div>
                        <div onClick={handleMaterialDelete}>
                           <Button
                              type="text"
                              disabled={item?.selling_count > 0}
                           >
                              {t("materialDashboard.deleteBtn")}
                           </Button>
                        </div>
                     </>
                  }
                  trigger="click"
                  placement="rightBottom"
               >
                  <MoreOutlined />
               </Popover>
            </div>
         </div>
      </Spin>
   );
};
